<div id="content">
	<div id="main">
		<ng-container [ngSwitch]="component">
			<dev-screen *ngSwitchCase="'dev-screen'"></dev-screen>
			<dashboard *ngSwitchCase="'dashboard'"></dashboard>
			<login *ngSwitchCase="'login'"></login>
			<user-preferences *ngSwitchDefault></user-preferences>
		</ng-container>
	</div>
</div>
